<div class="special-requirements-container" [style.vertical-align]="verticalAlign()">
    <mat-icon class="warning-icon" [matTooltip]="tooltipText() || ''"
        [matTooltipDisabled]="!tooltipText()">warning</mat-icon>
    @if (showLabel()) {
    <span class="warning-text">{{ label() }}</span>
    }
</div>